import { CATEGORY, COLOR, COLUMN, FORMATTING, JARGON, LAYOUT, POSITION, POSITION_ENUM, POSITION_TYPE } from "../../modules/constants"
import { addPaddingRightToLastCell, calcStats, getCell, getCellWithTooltip, headCell, setStats } from "../../modules/table.funcs"
import { initStats2 } from "../../components/layout/InitStats"
import { getTotDirectors } from "../../pages/companiesHouse/pageFunctions/complianceFunctions"

const { border1, integer, left, number, string } = FORMATTING
const stats2 = {}
const borderLeft = border1

export const createLseBoardHeadersData = props => {
    // console.log('createBoardHeadersData props:', props)
    const { portrait, showLogos, the350club } = props
    const width = "7%"

    const ceo = headCell({
        borderLeft,
        id: COLUMN.CEO,
        width,
    })

    const cfo = headCell({
        id: COLUMN.CFO,
        width,
    })

    const chair = headCell({
        borderLeft,
        id: COLUMN.NON_EXEC_CHAIR,
        width,
    })

    const company = headCell({
        align: left,
        colSpan: 2,
        id: COLUMN.COMPANY,
        label: "Company",
    })

    const directors = headCell({
        id: COLUMN.DIRECTORS,
        width,
    })

    const execs = headCell({
        id: COLUMN.EXECS,
        width,
    })

    const logoHead = headCell({
        align: left,
        id: COLUMN.LOGO,
        width: LAYOUT.LOGO_WIDTH,
    })

    const nonExecs = headCell({
        id: COLUMN.INDEP_NON_EXEC,
        width,
    })

    const otherDirs = headCell({
        borderLeft,
        id: COLUMN.OTHER_DIRS,
        width,
    })

    const secretaries = headCell({
        borderLeft,
        id: COLUMN.SECRETARY,
        width,
    })

    const sid = headCell({
        id: COLUMN.SID, // senior independent director
        label: getLabel(POSITION_ENUM.SENIOR_NON_EXEC),
        width,
    })

    const starHead = headCell({
        id: COLUMN.STAR,
        align: left,
        width: LAYOUT.STAR_WIDTH,
    })

    let headCells = portrait
        ? [starHead, company, directors]
        : [starHead, company, directors, ceo, cfo, execs, chair, sid, nonExecs, otherDirs, secretaries]

    if (showLogos)
        headCells.splice(1, 0, logoHead) // insert logo header

    if (the350club)
        headCells.shift() // Remove starHead

    addPaddingRightToLastCell(headCells)

    return headCells
}

const getLabel = positionEnum => POSITION[positionEnum].NAME

export const createLseBoardFooterData = props => {
    // console.log('createLseBoardFooterwData props:', props)
    const { portrait, showLogos, the350club } = props
    let column = null

    for (const property in stats2)
        calcStats(stats2[property])

    column = COLUMN.CEO
    const ceo = {
        total: getCell({ borderLeft, column, type: integer, value: stats2[column].total }),
        mean: getCell({ borderLeft, column, value: stats2[column].mean })
    }

    column = COLUMN.CFO
    const cfo = {
        total: getCell({ column, type: integer, value: stats2[column].total }),
        mean: getCell({ column, value: stats2[column].mean })
    }

    column = COLUMN.NON_EXEC_CHAIR
    const chair = {
        total: getCell({ borderLeft, column, type: integer, value: stats2[column].total }),
        mean: getCell({ borderLeft, column, value: stats2[column].mean })
    }

    column = COLUMN.COMPANY
    const suffix = ` ${stats2[column].total === 1 ? JARGON.COMPANY : JARGON.COMPANIES}`
    const company = {
        total: getCell({ align: left, column, suffix, type: integer, value: stats2[column].total }),
        mean: getCell({ column })
    }

    column = COLUMN.DIRECTORS
    const directors = {
        total: getCell({ column, type: integer, value: stats2[column].total }),
        mean: getCell({ column, value: stats2[column].mean })
    }

    column = COLUMN.EXECS
    const execs = {
        total: getCell({ column, type: integer, value: stats2[column].total }),
        mean: getCell({ column, value: stats2[column].mean })
    }

    column = COLUMN.INDEP_NON_EXEC
    const nonExecs = {
        total: getCell({ column, type: integer, value: stats2[column].total }),
        mean: getCell({ column, value: stats2[column].mean })
    }

    column = COLUMN.OTHER_DIRS
    const otherDirs = {
        total: getCell({ borderLeft, column, type: integer, value: stats2[column].total }),
        mean: getCell({ borderLeft, column, value: stats2[column].mean })
    }

    column = COLUMN.SECRETARY
    const secretaries = {
        total: getCell({ borderLeft, column, type: integer, value: stats2[column].total }),
        mean: getCell({ borderLeft, column, value: stats2[column].mean })
    }

    column = COLUMN.SID
    const sid = {
        total: getCell({ column, type: integer, value: stats2[column].total }),
        mean: getCell({ column, value: stats2[column].mean })
    }

    column = COLUMN.STAR
    const starFoot = {
        total: getCell({ column }),
        mean: getCell({ column })
    }

    column = COLUMN.LEGEND
    const legend = {
        total: getCell({ column, label: "Total:" }),
        mean: getCell({ column, label: "Average:" }),
    }

    const footCells = {
        totals: portrait
            ? [starFoot.total, company.total, legend.total, directors.total]
            : [starFoot.total, company.total, legend.total, directors.total, ceo.total, cfo.total, execs.total, chair.total, sid.total, nonExecs.total, otherDirs.total, secretaries.total],
        means: portrait
            ? [starFoot.mean, company.mean, legend.mean, directors.mean]
            : [starFoot.mean, company.mean, legend.mean, directors.mean, ceo.mean, cfo.mean, execs.mean, chair.mean, sid.mean, nonExecs.mean, otherDirs.mean, secretaries.mean]
    }

    if (showLogos) {
        const logoFoot = headCell({ id: COLUMN.LOGO, align: left })

        footCells.totals.splice(1, 0, logoFoot) // insert logo footer
        footCells.means.splice(1, 0, logoFoot) // insert logo footer
    }
    // console.log('footCells:', footCells)

    if (the350club) {
        footCells.totals.shift() // Remove starFoot
        footCells.means.shift()
    }

    addPaddingRightToLastCell(footCells.totals)
    addPaddingRightToLastCell(footCells.means)

    return footCells
}

export const createLseBoardRowData = props => {
    // console.log('createBoardRowData props:', props)
    const { items } = props
    const rows = []
    const tooltipTitle = "" // JARGON.MORE_INFO

    initStats2(stats2)

    items.forEach(item => {
        rows.push(createLseBoardRow({ ...props, item, tooltipTitle }))
    })

    return rows
}

const createLseBoardRow = ({ item, portrait, showLogos }) => {
    const { governance } = item
    const { roleCounts } = governance
    const directorsCount = getTotDirectors(roleCounts)
    const ceoColor = roleCounts[POSITION_TYPE.CEO] !== 1 ? COLOR.WARN : COLOR.BLACK
    const cfoColor = roleCounts[POSITION_TYPE.CFO] !== 1 ? COLOR.WARN : COLOR.BLACK
    const sidColor = roleCounts[POSITION_TYPE.SENIOR_NON_EXEC] !== 1 ? COLOR.WARN : COLOR.BLACK

    const ceo = getCellWithTooltip({ borderLeft, color: ceoColor, value: roleCounts[POSITION_TYPE.CEO] })
    const cfo = getCellWithTooltip({ color: cfoColor, value: roleCounts[POSITION_TYPE.CFO] })
    const name = getCellWithTooltip({ colSpan: 2, type: string, value: item.names[0] })
    const directors = getCellWithTooltip({ value: directorsCount })
    const execs = getCellWithTooltip({ value: roleCounts[POSITION_TYPE.OTHER_EXEC_DIRECTOR] })
    const chair = getCellWithTooltip({ borderLeft, value: roleCounts[POSITION_TYPE.CHAIRMAN] })
    const sid = getCellWithTooltip({ color: sidColor, type: number, value: roleCounts[POSITION_TYPE.SENIOR_NON_EXEC] })
    const secretaries = getCellWithTooltip({ borderLeft, value: roleCounts[POSITION_TYPE.SECRETARY] })
    const nonExecs = getCellWithTooltip({ value: roleCounts[POSITION_TYPE.NON_EXEC_DIRECTOR] })
    const other = getCellWithTooltip({ borderLeft, value: roleCounts[POSITION_TYPE.OTHER] })

    const logo = item.logo
        ? item.logo
        : "no logo"

    const rowCells = portrait
        ? [name, directors]
        : [name]

    if (!portrait)
        rowCells.push(ceo, cfo, execs, chair, sid, nonExecs, other, secretaries)

    const cellSpec = {
        [COLUMN.DIRECTORS]: {
            value: directorsCount,
            borderLeft,
        },
        [COLUMN.COMPANY]: {
            value: 1,
        },
        [COLUMN.CEO]: {
            value: roleCounts[POSITION_TYPE.CEO],
        },
        [COLUMN.CFO]: {
            value: roleCounts[POSITION_TYPE.CFO],
        },
        [COLUMN.EXECS]: {
            value: roleCounts[POSITION_TYPE.OTHER_EXEC_DIRECTOR],
        },
        [COLUMN.SID]: {
            value: roleCounts[POSITION_TYPE.SENIOR_NON_EXEC],
        },
        [COLUMN.NON_EXEC_CHAIR]: {
            value: roleCounts[POSITION_TYPE.CHAIRMAN],
        },
        [COLUMN.INDEP_NON_EXEC]: {
            value: roleCounts[POSITION_TYPE.NON_EXEC_DIRECTOR],
        },
        [COLUMN.OTHER_DIRS]: {
            value: roleCounts[POSITION_TYPE.OTHER],
        },
        [COLUMN.SECRETARY]: {
            value: roleCounts[POSITION_TYPE.SECRETARY],
        },
    }

    setStats(cellSpec[COLUMN.COMPANY].value, stats2[COLUMN.COMPANY], true)
    setStats(cellSpec[COLUMN.DIRECTORS].value, stats2[COLUMN.DIRECTORS], true)
    setStats(cellSpec[COLUMN.CEO].value, stats2[COLUMN.CEO], true)
    setStats(cellSpec[COLUMN.CFO].value, stats2[COLUMN.CFO], true)
    setStats(cellSpec[COLUMN.EXECS].value, stats2[COLUMN.EXECS], true)
    setStats(cellSpec[COLUMN.SID].value, stats2[COLUMN.SID], true)
    setStats(cellSpec[COLUMN.NON_EXEC_CHAIR].value, stats2[COLUMN.NON_EXEC_CHAIR], true)
    setStats(cellSpec[COLUMN.INDEP_NON_EXEC].value, stats2[COLUMN.INDEP_NON_EXEC], true)
    setStats(cellSpec[COLUMN.OTHER_DIRS].value, stats2[COLUMN.OTHER_DIRS], true)
    setStats(cellSpec[COLUMN.SECRETARY].value, stats2[COLUMN.SECRETARY], true)

    const cellWithTooltips = portrait
        ? [name, directors] // portrait
        : [name, directors, ceo, cfo, execs, chair, sid, nonExecs, other, secretaries]

    addPaddingRightToLastCell(cellWithTooltips)

    return {
        _id: item.ids[0],
        category: CATEGORY.COMPANY,
        cellWithTooltips,
        iconColor: COLOR.GOOD,
        ids: item.ids,
        index: item.index,
        isFavourite: item.isFavourite,
        link: `/company/${item.ids[0]}`,
        logo: showLogos ? logo : null, // insert logo
        title: item.companyName,
    }
}

